import {
  GET_INVOICE_HELPERS,
  SET_INVOICE
} from 'src/store/mutation-types'

export default {
  [GET_INVOICE_HELPERS] (state, helper) {
    state.invoiceHelpers = helper
  },
  [SET_INVOICE] (state, invoice) {
    state.invoice = invoice
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/store/mutations.js